import api from "@/api"

const state = {
  emails: [],
  selectedEmail: null,
  categories: [],
  studios: [],
  folders: [],
  loading: false,
  selectedFolder: "INBOX",
}

const mutations = {
  SET_EMAILS(state, emails) {
    state.emails = emails
  },
  SET_SELECTED_EMAIL(state, email) {
    state.selectedEmail = email
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_STUDIOS(state, studios) {
    state.studios = studios
  },
  SET_FOLDERS(state, folders) {
    state.folders = Object.keys(folders).map((key) => ({
      path: key,
      ...folders[key],
    }))
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_SELECTED_FOLDER(state, folder) {
    state.selectedFolder = folder
  },
  UPDATE_EMAIL(state, updatedEmail) {
    const index = state.emails.findIndex((email) => email._id === updatedEmail._id)
    if (index !== -1) {
      state.emails.splice(index, 1, updatedEmail)
      if (state.selectedEmail && state.selectedEmail._id === updatedEmail._id) {
        state.selectedEmail = updatedEmail
      }
    }
  },
  ARCHIVE_EMAIL(state, emailId) {
    state.emails = state.emails.filter((email) => email._id !== emailId)
    if (state.selectedEmail && state.selectedEmail._id === emailId) {
      state.selectedEmail = null
    }
  },
}

const actions = {
  fetchEmails({ commit }, folder) {
    commit("SET_LOADING", true)
    commit("SET_SELECTED_FOLDER", folder)
    return api.mails
      .getMails(folder)
      .then((response) => {
        commit("SET_EMAILS", response.data)
        commit("SET_LOADING", false)
      })
      .catch((error) => {
        console.error("Error fetching emails:", error)
        commit("SET_LOADING", false)
      })
  },
  selectEmail({ commit }, email) {
    commit("SET_SELECTED_EMAIL", email)
  },
  fetchFolders({ commit }) {
    return api.mails
      .getFolders()
      .then((response) => {
        commit("SET_FOLDERS", response.data)
      })
      .catch((error) => {
        console.error("Error fetching folders:", error)
      })
  },
  syncEmails({ dispatch, state }) {
    return api.mails.syncEmails().then(() => {
      dispatch("fetchEmails", state.selectedFolder)
    })
  },
  categorizeEmail({ commit }, { emailId, category, studioId }) {
    return api.mails.categorizeEmail(emailId, category, studioId).then((response) => {
      commit("UPDATE_EMAIL", response.data)
    })
  },
  fetchStudios({ commit, rootGetters }) {
    const studios = rootGetters["studioStore/getStudios"]
    commit("SET_STUDIOS", studios)
  },
  fetchCategories({ commit }) {
    // This is a placeholder. You need to implement the API endpoint to fetch categories.
    const categories = ["General", "Support", "Sales"]
    commit("SET_CATEGORIES", categories)
  },
  sendEmail({ commit }, { to, subject, text, replyTo }) {
    return api.mails.sendEmail(to, subject, text, replyTo).then(() => {
      if (replyTo) {
        commit("ARCHIVE_EMAIL", replyTo)
      }
    })
  },
  moveEmail({ dispatch }, { emailId, folderPath }) {
    return api.mails.moveEmail(emailId, folderPath).then(() => {
      dispatch("fetchEmails")
    })
  },
}

const getters = {
  emails: (state) => state.emails,
  selectedEmail: (state) => state.selectedEmail,
  categories: (state) => state.categories,
  studios: (state) => state.studios,
  folders: (state) => state.folders,
  loading: (state) => state.loading,
}

export const mailStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
